import {createAction, props} from '@ngneat/effects';
import {FilterDescriptors} from '@q9elements/ui-kit/components';

import {GridView} from './interfaces';

export const loadViews = createAction('[Grid views] Load views');
export const createView = createAction('[Grid views] Create view', props<{view?: GridView}>());
export const editView = createAction('[Grid views] Edit view', props<{view: GridView}>());
export const selectView = createAction('[Grid views] Select view', props<{id: string}>());
export const deleteView = createAction('[Grid views] Delete view', props<{view: GridView}>());
export const editFilters = createAction(
  '[Grid views] Edit view filters',
  props<{view: GridView}>()
);

export const updateGridFilters = createAction(
  '[Grid views] Update grid filters',
  props<{filters?: FilterDescriptors}>()
);
